/*@ngInject*/
const DataSetEditorNavController = function ($scope, $element, $state) {

    this.isActive = function (buttonName) {
        return $state.includes(buttonName);
    };
};

angular.module('ums.configuration')
    .controller('dataSetEditorNavController', DataSetEditorNavController);
